import React from 'react';
import { componentTypes } from '@white-nl/instantsearch-components';

import Xmark from '../icon/regular/Xmark';
import TrashCan from '../icon/regular/TrashCan';

export default function CurrentRefinements({
  currentRefinements,
  currentRefinementsSettings,
  clearRefinements,
}: componentTypes.CurrentRefinementsProps) {
  const { items, refine: refineCurrentRefinements } = currentRefinements;
  const { excludedAttributes } = currentRefinementsSettings;
  const { refine: refineClearRefinements } = clearRefinements;

  const activeFilters = items
    .filter((item) => !excludedAttributes?.includes(item.attribute))
    .flatMap((item) => item.refinements.map((nested) => nested));

  if (activeFilters.length === 0) {
    return null;
  }

  return (
    <>
      <div className="flex flex-wrap gap-2">
        {activeFilters.map((filter) => (
          <button
            key={`${filter.attribute}-${filter.value}`}
            className="inline-flex items-center gap-x-2.5 bg-white font-semibold text-sm lg:text-base text-gray-400 leading-none py-1.75 ps-3.75 pe-3.75 rounded-sm border border-gray-200 cursor-pointer transition hover:text-pink-400"
            type="button"
            onClick={() => refineCurrentRefinements(filter)}
          >
            {filter.label}
            <Xmark className="w-3 fill-current" />
          </button>
        ))}
      </div>
      <button
        className="inline-flex items-center font-semibold text-sm lg:text-base text-gray-950 gap-2 px-1.25 cursor-pointer transition hover:text-pink-400"
        type="button"
        onClick={refineClearRefinements}
      >
        <TrashCan className="w-3.5 fill-current" />
        {Craft.t('catalog', 'Clear all filters')}
      </button>
    </>
  );
}
